module.exports = __webpack_public_path__ + "fonts/Flaticon.35d544ea.eot";